export type SupplyTheme = "bright" | "dark";

/**
 * Supply is DAY-FIRST — same polarity as CluckUp now (operator flip,
 * 2026-08-17: the desk/manage crew live on a desktop browser in daylight far
 * more than the CK floor lives in a dim prep area). Bright is the working
 * default and dark stays a one-tap opt-in from the user menu — anyone who
 * already set `fb_supply_theme=dark` keeps it; only a cookieless or unknown
 * value now resolves to bright instead of dark.
 */
export const DEFAULT_SUPPLY_THEME: SupplyTheme = "bright";
export const SUPPLY_THEME_COOKIE = "fb_supply_theme";
export const SUPPLY_THEME_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

export function normalizeSupplyTheme(
  raw: string | null | undefined,
): SupplyTheme {
  return raw === "dark" ? "dark" : DEFAULT_SUPPLY_THEME;
}

/**
 * The one place a theme control writes the choice — DOM attribute (instant
 * paint) + cookie (persistence). PURE function, but touches `document`, so it
 * must only ever be CALLED from a "use client" event handler; defining it
 * here (rather than duplicating it in every toggle) is safe because nothing
 * runs at import time. SupplyThemeToggle's compact/segmented controls and
 * SupplyUserMenu's in-menu Day/Night control all share this one writer.
 */
export function applySupplyTheme(root: HTMLElement | null, next: SupplyTheme): void {
  if (root) root.dataset.supplyTheme = next;
  document.cookie = `${SUPPLY_THEME_COOKIE}=${next}; path=/; max-age=${SUPPLY_THEME_COOKIE_MAX_AGE}`;
}
